//@ts-ignore
import { AccessControl } from '@careinfo/permission-required';
// @ts-ignore
import { tw } from '@careinfo/tailwind'
import APIS from '../../../constant/Endpoint';
import NACell from '../../Reusable/DataTable/NACell';
import TableActionButton from '../../Reusable/TableActionButton';
import DataTable from '../../Reusable/DataTable';
import moment from 'moment';
const SmsHistoryContent = (props: any) => {
  const { handleIsActive, handleIsEnableEmail, handleIsEnableSMS } = props;
  const defaultColumns: any = [
    {
      header: 'Recipient',
      accessorKey: 'recipient',
      cell: NACell,
    },
    {
        header: "Date",
        accessorKey: "created_at",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              {getValue() ? (
                <p className={tw`max-w-[80px]`}>
                  {moment(getValue()).format("YY-MM-DD HH:mm:ss")}
                </p>
              ) : (
                "N/A"
              )}
            </>
          );
        },
      },
      {
      header: 'Content',
      accessorKey: 'content',
      cell: NACell,
    },
   
  ];

  return (
    <DataTable
      url={APIS.SMS_HISTORY}
      queryKey={'sms-history'}
      columns={defaultColumns}
      tableName={'Branch'}
    />
  );
};

export default SmsHistoryContent;
